import React, { useEffect, useState } from "react";
import { getCollectionListbyWalletAddress } from "../../../hooks/Collectionhook";
import DynamicCollectionCard from "../../collection/DynamicCardUI/DynamicCollectionCard";
import CollectionCardPlaceholder from "../CollectionCardPlaceholder";
import Pagination from "../../Pagination";
import { listNFTs } from "../../../hooks/NFTHook";

function CollectionProfile({user, address}) {
  const [collectionList, setCollectionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(6);
  const [isPagination, setIsPagination] = useState(false);
  const [pageCount, setPageCount] = useState(0);


  useEffect(() => {
    const fetchCollections = async () => {
      setLoading(true);
      const Query = { page: currentPage + 1, limit, ownerAddress: address, listed: true, isDraft: false };
      const data = await getCollectionListbyWalletAddress(Query);

      if (data.success) {
        const collections = data.data;

        // Fetch market data for each collection individually
        const collectionsWithMarketData = await Promise.all(
          collections.map(async (collection) => {
            const marketData = await fetchMarketData(collection.contractAddress);
            return { ...collection, marketData };
          })
        );

        setCollectionList(collectionsWithMarketData);
        setPageCount(data.totalPages);
        setIsPagination(data.totalPages > 1);
        setHasMore(data.total > 0);
      } else {
        setHasMore(false);
      }
      setLoading(false);
    };

    fetchCollections();
  }, [currentPage]);

  const fetchMarketData = async (contractAddress) => {
    const params = {
      page: 1,
      limit: 4,
      contractAddress,
      sortBy: "createdAt",
    };
    const marketData = await listNFTs(params);
    return marketData.success ? marketData : { success: false, data: [] };
  };

  const handlePageChange = (selectedItem) => {
    setCollectionList([]);
    setCurrentPage(selectedItem.selected);
  };

  console.log("colecir", collectionList);

  return (
    <>
      <div className="row justify-content-center mb-30_reset">
        <div className="row">
          {loading ? (
            [...Array(limit)].map((_, index) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                <CollectionCardPlaceholder />
              </div>
            ))
          ) : collectionList.length !== 0 ? (
            collectionList.map((val, i) => (
              <div className="col-lg-4 col-md-6 col-sm-12 card-hover-effect" key={i}>
                <DynamicCollectionCard
                  CollectionLink={`/collectionDetails/${val.contractAddress}`}
                  marketItem={val.marketData?.data || []}
                  contractAddress={val.contractAddress}
                  ownerDetails={val.ownerDetails}
                  collectionName={val.name}
                  collectionLogo={val.logo}
                  owner={false}
                  totalMarketItem={val.marketData?.total || 0}
                />
              </div>
            ))
          ) : (
            <h3>No own Collection available</h3>
          )}
        </div>

        {isPagination && (
          <div>
            <Pagination pageCount={pageCount} onPageChange={handlePageChange} currentPage={currentPage} />
          </div>
        )}
      </div>
    </>
  );
}

export default CollectionProfile;
